/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guide_Json_Syntax_Errors_Faq_A1Inputs */

const en_guide_json_syntax_errors_faq_a1 = /** @type {(inputs: Guide_Json_Syntax_Errors_Faq_A1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Douglas Crockford, who specified JSON, deliberately omitted comments to keep the format simple and to prevent abuse of comments for parsing directives. For files that need comments, consider YAML or JSONC.`)
};

const ko_guide_json_syntax_errors_faq_a1 = /** @type {(inputs: Guide_Json_Syntax_Errors_Faq_A1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON을 명세한 Douglas Crockford는 포맷을 단순하게 유지하고 파싱 지시자로의 주석 남용을 방지하기 위해 의도적으로 주석을 생략했습니다. 주석이 필요한 파일에는 YAML이나 JSONC를 고려하세요.`)
};

const ja_guide_json_syntax_errors_faq_a1 = /** @type {(inputs: Guide_Json_Syntax_Errors_Faq_A1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSONを仕様化したDouglas Crockfordは、フォーマットをシンプルに保ち、コメントがパース指示に悪用されるのを防ぐために意図的にコメントを省きました。コメントが必要なファイルには、YAMLやJSONCを検討してください。`)
};

/**
* | output |
* | --- |
* | "Douglas Crockford, who specified JSON, deliberately omitted comments to keep the format simple and to prevent abuse of comments for parsing directives. For f..." |
*
* @param {Guide_Json_Syntax_Errors_Faq_A1Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guide_json_syntax_errors_faq_a1 = /** @type {((inputs?: Guide_Json_Syntax_Errors_Faq_A1Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guide_Json_Syntax_Errors_Faq_A1Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guide_json_syntax_errors_faq_a1(inputs)
	if (locale === "ko") return ko_guide_json_syntax_errors_faq_a1(inputs)
	return ja_guide_json_syntax_errors_faq_a1(inputs)
});